import React, { Component } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'
import Icon from '../../Icon'

class Input extends Component {
  render () {
    const classNames = ['InputText']
    let label
    if (this.props.label !== undefined) {
      label = <label>{this.props.label + (this.props.required ? ' *' : '')}</label>
    }

    let message
    if (this.props.valid !== true && this.props.message) {
      message = <span>{this.props.message}</span>
      classNames.push('InputTextError')
    }

    let icon
    if (this.props.tooltip) {
      icon = <span><Icon size={'small'} type={'info'} tooltip={this.props.tooltip}/></span>
    }

    if (this.props.round === true) {
      classNames.push('input-text-round')
    }

    if (this.props.alignRight === true) {
      classNames.push('input-text-align-right')
    }

    return (
      <div className={classNames.join(' ')}>
        {label} {icon} {message}
        <div className={'input-group'}>
          <input type={this.props.type}
                 placeholder={this.props.placeholder}
                 disabled={this.props.disabled}
                 required={this.props.required}
                 onChange={this.props.onChange}
                 value={this.props.value}
          />
          {this.props.append ? <div className={'input-group-append'}>{this.props.append}</div> : null}
        </div>
      </div>
    )
  }
}

Input.defaultProps = {
  type: 'text',
  placeholder: '',
  disabled: false,
  required: false,
  valid: true,
  round: false,
  alignRight: false
}

Input.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  valid: PropTypes.bool,
  round: PropTypes.bool,
  message: PropTypes.string,
  append: PropTypes.element,
  alignRight: PropTypes.bool,
  tooltip: PropTypes.string
}

export default Input
